<template>
  <div class="facts">
    <h2>Facts</h2>
    <h3 v-if="scenarioData.description" @click="contextOpen = !contextOpen">
      <i class="material-icons" v-if="!contextOpen">keyboard_arrow_right</i>
      <i class="material-icons" v-else>keyboard_arrow_down</i>
      Context
    </h3>
    <div v-if="contextOpen" v-html="scenarioData.description" class="hidden-content"></div>

    <h3 v-if="playlistData.facts" @click="factsOpen = !factsOpen">
      <i class="material-icons" v-if="!factsOpen">keyboard_arrow_right</i>
      <i class="material-icons" v-else>keyboard_arrow_down</i>
      Facts
    </h3>
    <ul v-if="factsOpen" class="hidden-content">
      <li v-for="(fact, index) in playlistData.facts" :key="index">{{fact}}</li>
    </ul>
  </div>
</template>

<script>
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "Fact",
  mixins: [scenarioMixin],
  data () {
    return {
      contextOpen: false,
      factsOpen: false,
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
h2 {
  color: var(--primary);
  width: 100%;
  margin-bottom: 1em;
  // padding: 0 20px;
}
h3 {
  cursor: pointer;
  color: var(--primary);
  border-top: 2px solid #E2E8FF;
  display: flex;
  align-items: center;
  font-size: 18px;
  padding: 15px 0;
}
.hidden-content {
  margin: 0.5em 0;
  color: var(--primary);
}
.facts {
  padding: 25px;
}
</style>